import { useQuery } from "@tanstack/react-query";
import { getAgencySection } from "../../api/apiAgencySection";

export const useGetAgencySection = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["agency-section"],
        queryFn: getAgencySection,
    });

    return {
        agencySection: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
